// Module
var code = "<div id=\"top-level-content-container\"> <div id=\"mfa-form-container\"> <div id=\"mfa-title-container\"> <span id=\"mfa-choice-title\" class=\"banner-text\"></span> </div> <div id=\"mfa-choice-preamble\"></div> <div id=\"mfa-enrollments-wrapper\"></div> </div> </div> ";
// Exports
export default code;